import { BaseScatola, BaseTitolo, formattaData } from '@lucan/base-ui'
import { DATE_MODALITA, DATE_MODALITA_LABEL, LabelTipologiaPermesso, PermessoBase } from '@lucan/base-ui-jconnet'

export default function PassDettagliPermesso(props) {
  const {
    permesso,
    optionsPrefissi,
    optionsTipologie,
    optionsVarchi,
    optionsZoneSosta,
    val,
    txt
  } = props

  const {
    datiBase: {
      dataInizio,
      dataFine,
      permessoBase,
      tipologiaId,
      usaTipologia,
    },
  } = permesso

  return (
    <BaseScatola>
      <BaseTitolo>Dettagli permesso</BaseTitolo>

      <PermessoBase
        permessoBase={permessoBase}
        optionsPrefissi={optionsPrefissi}
        optionsVarchi={optionsVarchi}
        optionsZoneSosta={optionsZoneSosta}
        mostraDateModalita={false}
        mostraImporto={false}
        altriDatiTabella={{
          'Tipologia': (
            <LabelTipologiaPermesso
              tipologiaId={tipologiaId}
              optionsTipologie={optionsTipologie}
              usaTipologia={usaTipologia}
            />
          ),
          'Validità': permessoBase.dateModalita === DATE_MODALITA.TUTTE
            ? DATE_MODALITA_LABEL[DATE_MODALITA.TUTTE]
            : (
              <>
                {dataInizio && <>Inizio: {formattaData(dataInizio)}</>}
                {dataInizio && dataFine && <br />}
                {dataFine && <>Fine: {formattaData(dataFine)}</>}
              </>
            )
        }}
      />
    </BaseScatola>
  )
}